/* Orvani - ventana emergente de captacion de email */
(function(){
  'use strict';
  var KEY='dnPopState';
  var MIN_DWELL=3000;

  function read(){try{return JSON.parse(localStorage.getItem(KEY)||'{}')}catch(e){return{}}}
  function write(o){try{localStorage.setItem(KEY,JSON.stringify(o))}catch(e){}}

  function init(){
    var pop=document.querySelector('[data-dn-pop]');
    if(!pop||pop.dataset.dnInit)return;
    pop.dataset.dnInit='1';

    var success=!!pop.querySelector('[data-dn-pop-success]');
    var st=read();
    var opened=false, lastFocus=null;
    var loadedAt=Date.now();
    var timer=null;

    function open(){
      if(opened)return; opened=true;
      lastFocus=document.activeElement;
      pop.hidden=false;
      void pop.offsetWidth; // fuerza reflow: la transicion arranca sin depender de rAF
      pop.classList.add('is-open');
      document.documentElement.style.overflow='hidden';
      var f=pop.querySelector('input[type=email],[data-dn-pop-copy],.dn-pop__cta');
      if(f)setTimeout(function(){try{f.focus()}catch(e){}},320);
    }

    function close(){
      if(!opened)return; opened=false;
      pop.classList.remove('is-open');
      document.documentElement.style.overflow='';
      setTimeout(function(){pop.hidden=true},300);
      if(lastFocus&&lastFocus.focus){try{lastFocus.focus()}catch(e){}}
      if(!success){st.snoozedAt=Date.now();write(st);}
    }

    pop.addEventListener('click',function(e){
      if(e.target.closest&&e.target.closest('[data-dn-pop-close]'))close();
    });
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape'&&opened)close();
    });

    var copyBtn=pop.querySelector('[data-dn-pop-copy]');
    if(copyBtn){
      copyBtn.addEventListener('click',function(){
        var c=copyBtn.dataset.code||'';
        var done=function(){copyBtn.classList.add('is-copied')};
        if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(c).then(done).catch(done)}
        else{done()}
      });
    }

    // Alta correcta: mostrar el codigo y no volver a molestar
    if(success){
      st.subscribed=true; write(st);
      setTimeout(open,400);
      return;
    }

    if(st.subscribed)return;
    var snoozeDays=parseInt(pop.dataset.snooze,10)||14;
    if(st.snoozedAt&&Date.now()-st.snoozedAt<snoozeDays*864e5)return;

    var delay=(parseInt(pop.dataset.delay,10)||6)*1000;
    timer=setTimeout(open,delay);

    // Salida del raton en escritorio, solo tras un tiempo minimo en pagina
    document.addEventListener('mouseout',function(e){
      if(opened||e.relatedTarget||e.clientY>60)return;
      if(window.innerWidth<750)return;
      if(Date.now()-loadedAt<MIN_DWELL)return;
      clearTimeout(timer);open();
    });

    // Scroll en movil
    var onScroll=function(){
      if(opened)return;
      var h=document.documentElement;
      var pct=h.scrollTop/((h.scrollHeight-h.clientHeight)||1);
      if(pct>0.45){clearTimeout(timer);open();window.removeEventListener('scroll',onScroll)}
    };
    window.addEventListener('scroll',onScroll,{passive:true});
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();
